export const ERROR_CODE_SESSION_UNREACHABLE = 'EWCERRORDOMAIN7007';
